import { t } from "i18next";

export function convertiMese(mese) {
    if (!mese) return
    let meseStr = ""
    try {
        switch (mese) {
            case 0:
                meseStr = t("month.jan");
                break;
            case 1:
                meseStr = t("month.feb");
                break;
            case 2:
                meseStr = t("month.mar");
                break;
            case 3:
                meseStr = t("month.apr");
                break;
            case 4:
                meseStr = t("month.may");
                break;
            case 5:
                meseStr = t("month.jun");
                break;
            case 6:
                meseStr = t("month.jul");
                break;
            case 7:
                meseStr = t("month.aug");
                break;
            case 8:
                meseStr = t("month.sep");
                break;
            case 9:
                meseStr = t("month.oct");
                break;
            case 10:
                meseStr = t("month.nov");
                break;
            case 11:
                meseStr = t("month.dec");
                break;
            default:
                throw new Error("Errore nella ricerca del mese");
        }
    } catch (err) {
        console.error("Error: ", err)
    }
    return meseStr;
}

//Funzioni per formattare valori
export function formattaFloat(variable) {
    const typeVar = typeof (variable)
    var formattedFloat
    if (typeVar === "string") formattedFloat = parseFloat(variable)
    else formattedFloat = parseFloat(variable.toFixed(2))
    return formattedFloat;
}

//Funzioni per formattare valori delle fatture
export function formattaFloatFatture(variable) {
    var result_x100 = Number(variable)* 100
    var result_floor = Math.floor(result_x100)
    var mantissa = result_x100 - result_floor
    if(mantissa - 0.5 > 0)
        return Math.ceil(result_x100)/100
    else
        return result_floor/100
}
